import { GetEmailConfirmationType } from 'types/services';
import { m8API } from '../m8';

export const getEmailConfirmationType: GetEmailConfirmationType = async (
  params
) => {
  const pretty = await m8API.auth.isEmailPretty({
    email: params.emailAddress,
  });

  if (pretty) {
    return 'WITH_CODE';
  }

  return 'WITH_PASSWORD';
};
